import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8",
            lg: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h6 pa-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { class: "mr-2" }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-account-plus")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _cache[11] || (_cache[11] = _createTextVNode(" Provision Underwriter "))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  ($setup.loading)
                    ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                        key: 0,
                        indeterminate: "",
                        color: "primary"
                      }))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      ($setup.errorMessage)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "error",
                            variant: "tonal",
                            class: "mb-4",
                            closable: "",
                            "onClick:close": _cache[0] || (_cache[0] = ($event: any) => ($setup.errorMessage = null))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.errorMessage), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_v_form, {
                        ref: "formRef",
                        onSubmit: _withModifiers($setup.submit, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select, {
                                    modelValue: $setup.form.department,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.department) = $event)),
                                    items: $setup.departments,
                                    label: "Department *",
                                    variant: "outlined",
                                    density: "comfortable",
                                    rules: [v => !!v || 'Department is required'],
                                    disabled: $setup.loading
                                  }, null, 8 /* PROPS */, ["modelValue", "items", "rules", "disabled"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.firstName,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.firstName) = $event)),
                                    label: "First Name *",
                                    variant: "outlined",
                                    density: "comfortable",
                                    maxlength: "40",
                                    rules: [
											v => !!v || 'First name is required',
											v => v.length <= 40 || 'Max 40 characters',
										],
                                    disabled: $setup.loading,
                                    onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.form.firstName = $setup.form.firstName.toUpperCase()))
                                  }, null, 8 /* PROPS */, ["modelValue", "rules", "disabled"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.middleName,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.middleName) = $event)),
                                    label: "Middle Name",
                                    variant: "outlined",
                                    density: "comfortable",
                                    maxlength: "40",
                                    rules: [v => !v || v.length <= 40 || 'Max 40 characters'],
                                    disabled: $setup.loading,
                                    onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.form.middleName = $setup.form.middleName?.toUpperCase()))
                                  }, null, 8 /* PROPS */, ["modelValue", "rules", "disabled"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: $setup.form.lastName,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.lastName) = $event)),
                                    label: "Last Name *",
                                    variant: "outlined",
                                    density: "comfortable",
                                    maxlength: "60",
                                    rules: [
											v => !!v || 'Last name is required',
											v => v.length <= 60 || 'Max 60 characters',
										],
                                    disabled: $setup.loading,
                                    onInput: _cache[7] || (_cache[7] = ($event: any) => ($setup.form.lastName = $setup.form.lastName.toUpperCase()))
                                  }, null, 8 /* PROPS */, ["modelValue", "rules", "disabled"])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onSubmit"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_m_btn, {
                        to: { path: '/SSAM/underwriters' },
                        disabled: $setup.loading
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode(" Cancel ")
                        ])),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"]),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_m_btn, {
                        color: "primary",
                        "prepend-icon": "mdi-content-save",
                        loading: $setup.loading,
                        onClick: $setup.submit
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode(" Provision Underwriter ")
                        ])),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["loading", "onClick"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: $setup.showSuccess,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.showSuccess) = $event)),
        color: "success",
        timeout: 4000,
        location: "top"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showSuccess = false))
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("Close")
            ])),
            _: 1 /* STABLE */
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.successMessage) + " ", 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ]),
    _: 1 /* STABLE */
  }))
}